module.exports = __webpack_public_path__ + "assets/img/more.a4351109.svg";